import { createTheme, ThemeProvider, useThemeMode } from 'flowbite-react';
import { PropsWithChildren, useEffect } from 'react';

const customTheme = createTheme({
    button: {
        base: "hover:cursor-pointer text-center text-white dark:text-black font-medium rounded-lg text-sm px-5 py-2.5 ",
        disabled: "disabled:cursor-not-allowed disabled:bg-gray-200 disabled:dark:bg-gray-500",
        color: {
            primary: "bg-alfa1-brand-primary-500 hover:bg-alfa1-brand-primary-700",
            secondary: "bg-alfa1-brand-secondary-300 hover:bg-alfa1-brand-secondary-700",
            clear: "bg-transparent border-0 text-black dark:text-white"
        },
        outlineColor: {
            primary: "border border-1 border-alfa1-brand-primary-500 hover:border-alfa1-brand-primary-700 text-gray-900 dark:text-white",
            secondary: "border border-1 border-alfa1-brand-secondary-300 hover:border-alfa1-brand-secondary-700 text-gray-900 dark:text-white"
        }
    },
    progress: {
        color: {
            default: "bg-alfa1-brand-secondary-300"
        }
    },
    label: {
        root: {
            colors: {
                default: "text-gray-900 dark:text-white"
            }
        }
    },
    textInput: {
        base: "text-gray-900 dark:text-white focus:border-alfa1-brand-secondary-300 focus:ring-alfa1-brand-secondary-300 ",
    },
    accordion: {
        title: {
            base: "flex w-full items-center justify-between p-5 text-left font-small text-gray-500 first:rounded-t-lg last:rounded-b-lg dark:text-gray-400",
        }
    }
})

export const Theme = ({children}: PropsWithChildren) => {
    const {setMode} = useThemeMode()

    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

        const handleChange = (e : MediaQueryListEvent) => {
            const mode = e.matches ? "dark" : "light"
            console.log("Setting mode " + mode)

            setMode(mode);
        };

        setMode(mediaQuery.matches ? "dark" : "light")

        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, [setMode]);

    return (
        <>
            <ThemeProvider theme={customTheme}>
                {children}
            </ThemeProvider>
        </>
    )
}